module.exports = function getQueryName(type) {
    switch(type) {
        case 'packageLicencePlate':
            return 'PackageLicencePlate';
        case 'waybill':
            return 'WayBillNo';
        case 'sendersReference':
            return 'SendersReference';
        default:
            throw new Error(`Unknown search type: ${type}`);
    }
};
